import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import ArticleData from '../components/article-data';

export default ({ data, data: { prismicDataProjects: node }, location: { pathname } }) => {
    const articleProps = {
        pathname,
        uid: node.uid,
        embed: node.data.embed.text,
        title: node.data.title.text,
        body: node.data.description.html,
        bodyText: node.data.description.text,
        date: (new Date(node.last_publication_date)).toLocaleDateString('en-US', {
            day: 'numeric',
            year: 'numeric',
            month: 'short'
        })
    };

    return <Layout pathname={pathname}><ArticleData {...articleProps} /></Layout>;
};

export const query = graphql`
    query DataQuery($uid: String!) {
        prismicDataProjects(uid: { eq: $uid }) {
            last_publication_date
            uid
            data {
                title {
                    text
                }
                description {
                    text
                    html
                }
                embed {
                    text
                }
            }
        }
    }
`;
